export { default } from 'common/models/product';
